import { supabase } from '@/lib/supabase'
import type { Book } from '@/types/booky'

interface UpsertBookInput {
  userId: string
  isbn13: string
  title: string
  authors: string[]
  coverUrl: string | null
  rawPayload: unknown
}

export const useBooks = () => {
  const upsertBook = async (input: UpsertBookInput) => {
    const payload = {
      user_id: input.userId,
      isbn13: input.isbn13,
      title: input.title,
      authors: input.authors,
      cover_url: input.coverUrl,
      raw_api_payload: input.rawPayload,
      updated_at: new Date().toISOString(),
    }

    const { data, error } = await supabase
      .from('booky_books')
      .upsert(payload, { onConflict: 'user_id,isbn13' })
      .select('id, isbn13, title, authors, cover_url, raw_api_payload, created_at')
      .single()

    return {
      data: (data ?? null) as Book | null,
      error,
    }
  }

  return {
    upsertBook,
  }
}
